module.exports = "/_next/static/media/extension-preview.8590c927.png";